const sx = {
  heroSection: {
    position: 'relative',
    minHeight: { xs: 'auto', md: '85vh' },
    display: 'flex',
    alignItems: 'center',
    py: { xs: 8, md: 0 },
    overflow: 'hidden',
  },
  backgroundWrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    zIndex: 0,
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.2)',
    zIndex: 1,
  },
  contentContainer: {
    position: 'relative',
    zIndex: 2,
  },
  leftColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center!importat',
    alignItems: 'center!importat',
    textAlign: 'center!importat',
    color: 'white',
    mb: { xs: 6, md: 0 },
  },
  logoContainer: {
    width: '100%',
    mb: 4,
    alignItems: 'center!important',
    textAlign: 'center!important',
    justifyContent: 'center!important',
  },
  mainTitle: {
    fontWeight: 800,
    fontSize: { xs: '2rem', md: '2.5rem' },
    lineHeight: 1.1,
    textTransform: 'uppercase',
    textShadow: '0px 4px 10px rgba(0,0,0,0.5)',
    mb: 2,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: { xs: '1.1rem', md: '1.3rem' },
    textShadow: '0px 2px 5px rgba(0,0,0,0.5)',
    textAlign: 'center',
  },
}

export default sx
